// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.reportPrintNormal {\n    border-style: none;\n    font-family: 'Courier New', sans-serif;\n    font-size: 10pt;\n    vertical-align: top;\n}\n.tdLeftTop {\n    margin: 0px 0px 0px 0px;\n    padding-right: 10px;\n    text-align: left;\n    vertical-align: top;\n}\n", ""]);
// Exports
module.exports = exports;
